import React, { useState, useEffect } from 'react';

/**
 * Filter bar for the CEO Requests list (feature 066-ceo-requests): a search box, an inclusive
 * date range, and Apply / Clear / Export.
 *
 * Uses the shared `au-` filter system (au-filters / au-field / au-input / au-select / au-btn) so
 * it matches every other portal filter bar. Export lives inside this bar, as it does on the
 * other screens — not as a separate button elsewhere on the page.
 *
 * ONE SEARCH BOX, THREE FIELDS. The backend matches the term against sender name, email AND
 * message text at once. Splitting these into separate controls would be more precise and less
 * useful: an admin chasing a request usually has one identifier and does not know which field it
 * lives in.
 *
 * The member id is NOT among them. It is a bare number, so it collides with any digits a member
 * typed into their own message — searching an id would mix the one member it identifies in with
 * every letter that happens to mention that figure, and nothing in the result distinguishes them.
 *
 * There is deliberately NO platform selector here, unlike the screen this one replaces — the app
 * does not record a platform on a Firestore request, so the control would filter on nothing.
 */
const EMPTY = { search: '', from: '', to: '' };

export default function CeoRequestsFilters({ values, onApply, onClear, onExport }) {
  const [local, setLocal] = useState({ ...EMPTY, ...values });
  useEffect(() => { setLocal({ ...EMPTY, ...values }); }, [values]);

  const set = (k, v) => setLocal((p) => ({ ...p, [k]: v }));
  const submit = (e) => { if (e) e.preventDefault(); onApply(local); };

  return (
    <form className="au-filters cr-filters" aria-label="Request filters" onSubmit={submit}>
      {/* The fields wrap among themselves; the actions never leave their row. */}
      <div className="au-filters__fields">
        <div className="au-field cr-field-grow">
          <span className="au-field__label">Search</span>
          <input
            aria-label="Search requests"
            className="au-input"
            placeholder="Name, email or message"
            value={local.search}
            onChange={(e) => set('search', e.target.value)}
          />
        </div>

        <div className="au-field">
          <span className="au-field__label">From</span>
          <input
            aria-label="From date"
            className="au-select"
            type="date"
            value={local.from}
            onChange={(e) => set('from', e.target.value)}
          />
        </div>

        <div className="au-field">
          <span className="au-field__label">To</span>
          <input
            aria-label="To date"
            className="au-select"
            type="date"
            value={local.to}
            onChange={(e) => set('to', e.target.value)}
          />
        </div>

      </div>

      <div className="au-field au-field--actions cr-actions">
        <button type="submit" className="au-btn au-btn--primary">Apply</button>
        <button
          type="button"
          className="au-btn au-btn--ghost"
          onClick={() => { setLocal({ ...EMPTY }); onClear(); }}
        >
          Clear
        </button>
        <button type="button" className="au-btn au-btn--ghost" onClick={onExport}>⬇ Export CSV</button>
      </div>
    </form>
  );
}
